var _script, _path, _script2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _script || (_script = /*#__PURE__*/React.createElement("script", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "m9 0 2.02 6.219h6.54l-5.29 3.843 2.02 6.22L9 12.437 3.71 16.28l2.02-6.219L.44 6.22h6.54z"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", null)));
};
export default SvgStar;